import { render, staticRenderFns } from "./SGoodsCatePointe.vue?vue&type=template&id=4de2145b&scoped=true"
import script from "./SGoodsCatePointe.vue?vue&type=script&lang=js"
export * from "./SGoodsCatePointe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2145b",
  null
  
)

export default component.exports